import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React, { Component } from 'react';
import LocaleUtils from './LocaleUtils';
import { ENTER } from './keys';

var Caption = /*#__PURE__*/function () {
  var Caption = /*#__PURE__*/function (_Component) {
    _inheritsLoose(Caption, _Component);

    function Caption(props) {
      var _this;

      _this = _Component.call(this, props) || this;
      _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
      return _this;
    }

    var _proto = Caption.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    };

    _proto.handleKeyUp = function handleKeyUp(e) {
      if (e.keyCode === ENTER) {
        this.props.onClick(e);
      }
    };

    _proto.render = function render() {
      var _this$props = this.props,
          classNames = _this$props.classNames,
          date = _this$props.date,
          months = _this$props.months,
          locale = _this$props.locale,
          localeUtils = _this$props.localeUtils,
          onClick = _this$props.onClick;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames.caption,
        role: "heading",
        "aria-live": "polite"
      }, /*#__PURE__*/React.createElement("div", {
        onClick: onClick,
        onKeyUp: this.handleKeyUp
      }, months ? months[date.getMonth()] + " " + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)));
    };

    return Caption;
  }(Component);

  Caption.defaultProps = {
    localeUtils: LocaleUtils
  };
  return Caption;
}();

export default Caption;